import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { paddingConverter, paddingDefaultProps, paddingPropTypes } from 'Components/ComponentLibrary/DesignSystem/padding';

const useStyles = buildUseStyles('HorizontalStack', (theme) => ({
  root: {
    display: 'flex',
    gap: props => `${theme.spacing(props.spacing)}px`,
    flexWrap: props => (props.wrap ? 'wrap' : 'nowrap'),
    justifyContent: props => props.justify,
    width: '100%',
    height: '100%',
    padding: (props) => paddingConverter(theme, props),
  },
  rootAlignCenter: {
    alignItems: 'center',
  },
}));

const HorizontalStack = (props) => {
  const {
    children,
    alignment,
  } = props;

  const classes = useStyles(props);

  return (
    <Box
      className={classNames(classes.root, {
        [classes.rootAlignCenter]: alignment === 'centered',
      })}
    >
      {children}
    </Box>
  );
};

HorizontalStack.defaultProps = {
  ...paddingDefaultProps,
  alignment: 'default',
  justify: 'flex-start',
  spacing: 0,
  wrap: false,
};

HorizontalStack.propTypes = {
  ...paddingPropTypes,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  alignment: PropTypes.oneOf(['centered', 'default']),
  justify: PropTypes.oneOf([
    'flex-end',
    'flex-start',
    'center',
    'space-around',
    'space-between',
    'space-evenly',
  ]),
  spacing: PropTypes.number,
  wrap: PropTypes.bool,
};

export default HorizontalStack;
